module.exports = __webpack_public_path__ + "static/media/wds-logo.0af180ba.svg";